import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { MASTER_CHECKBOX_STATUS } from '../../WinLossReducer';

class CheckboxHeaderRenderer extends Component {
  constructor() {
    super();
    this.state = {};
    this.hanldeToggleAll = this.hanldeToggleAll.bind(this);
  }

  hanldeToggleAll() {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.requestToggleAll();
    }
  }

  render() {
    const { disabled, status } = this.props;
    let icon = 'square-o';
    let cls = null;
    if (status === MASTER_CHECKBOX_STATUS.none) {
      icon = 'square-o';
      cls = 'text-muted';
    } else if (status === MASTER_CHECKBOX_STATUS.partial) {
      icon = 'minus-square-o';
    } else if (status === MASTER_CHECKBOX_STATUS.full) {
      icon = 'check-square';
      cls = 'text-success';
    }

    return (
      <div 
        style={{ cursor: (disabled ? 'not-allowed' : 'pointer'), fontSize: '1.2em' }} 
        onClick={this.hanldeToggleAll}
      >
        <Fa name={icon} className={cls} />
      </div>
    );
  }
}

CheckboxHeaderRenderer.propTypes = {
  disabled: PropTypes.bool,
  status: PropTypes.string.isRequired,
  requestToggleAll: PropTypes.func,
};
CheckboxHeaderRenderer.defaultProps = {
  disabled: false,
  requestToggleAll: () => {},
};

export default CheckboxHeaderRenderer;
